import { useLocation } from "react-router-dom"

import { useRoutes } from "@/contexts/use-routes"

import { resolveDocumentAiAssistRouteId } from "../utils/ai-assist-route-utils"

/** Enabled-route id for document AI assist, or null when the page is not a module. */
export function useDocumentAiAssistRouteId(): string | null {
  const { routes } = useRoutes()
  const { pathname } = useLocation()
  return resolveDocumentAiAssistRouteId(routes, pathname)
}
